import { useEffect, Dispatch } from 'react';
import { requestZoomIntegrationApi, selectZoomIntegration } from '~/store/zoom/integration';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useProvider } from '~/Hooks';
import { ExtendedEventGroup } from '~/Screens/Events/EventCreate/ExtendedEventGroup.model';

export const useZoomIntegration = ({
  setEventGroup,
}: {
  setEventGroup: Dispatch<React.SetStateAction<ExtendedEventGroup>>;
}) => {
  const dispatch = useDispatch();
  const zoomIntegration = useSelector(selectZoomIntegration);
  const getZoomApi = bindActionCreators(requestZoomIntegrationApi, dispatch);
  const { currentProvider } = useProvider();

  useEffect(() => {
    currentProvider && getZoomApi({ providerId: currentProvider.uuid });
  }, [currentProvider]);

  useEffect(() => {
    if (zoomIntegration?.authorized) {
      setEventGroup((prev) => ({
        ...prev,
        hasAccessToZoom: true,
        isZoomSelected: false,
        isZoomWebinar: false,
      }));
    }
  }, [zoomIntegration]);
};
